export enum Tab {
  Analyzes = 'Анализы',
  Diseases = 'Заболевания',
  GlossaryTerms = 'Словарь генетических терминов',
}
